import { render, staticRenderFns } from "./bet-creator-ratios.vue?vue&type=template&id=3a7b63a8&scoped=true&"
import script from "./bet-creator-ratios.vue?vue&type=script&lang=js&"
export * from "./bet-creator-ratios.vue?vue&type=script&lang=js&"
import style0 from "./bet-creator-ratios.vue?vue&type=style&index=0&id=3a7b63a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b63a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a7b63a8')) {
      api.createRecord('3a7b63a8', component.options)
    } else {
      api.reload('3a7b63a8', component.options)
    }
    module.hot.accept("./bet-creator-ratios.vue?vue&type=template&id=3a7b63a8&scoped=true&", function () {
      api.rerender('3a7b63a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/bet-creator-ratios.vue"
export default component.exports